import type { QueryClient } from '@tanstack/react-query';

/** Consultas de assinatura compartilhadas pelo guard, banners e área da conta. */
export const subscriptionQueryKeys = {
  subscription: ['my-subscription'],
  subscriptionWarning: ['my-subscription-warning'],
} as const;

export const subscriptionQueriesToRefresh = Object.values(subscriptionQueryKeys);

/** Recarrega as consultas de assinatura compartilhadas (guard, banner, conta). */
export const refreshSubscriptionQueries = async (queryClient: QueryClient): Promise<void> => {
  await Promise.all(
    subscriptionQueriesToRefresh.map((queryKey) => queryClient.invalidateQueries({ queryKey })),
  );
};
